module.exports = __webpack_public_path__ + "img/clouseediteMenu.b6c7b37e.svg";